import { useState } from "react";
import apiData from "lib/stores/apiData";
import context from "lib/stores/context";
import classNames from "classnames";
import styles from "./MapControlsToolbars/index.module.scss";
import ToolbarControl from "components/common/Toolbar/ToolbarControl";
import RadixSelect from "components/common/RadixSelect";
import { ReactComponent as IconLayers } from "components/icons/Layers.svg";
import { useSnapshot } from "valtio";

const DownloadButton = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [groups, setGroups] = useState(null);
  const { activeView, activeCountry, activeRegion } = useSnapshot(context);
  const { countries, regions, globals } = useSnapshot(apiData);

  const getDownloadLinks = () => {
    if (activeView === "region") {
      return [
        {
          label: "DOWNLOAD PNG",
          value: regions[activeRegion]?.download_urls[0]
        },
        {
          label: "DOWNLOAD PDF",
          value: regions[activeRegion]?.download_urls[1]
        },
        {
          label: "DOWNLOAD JPEG",
          value: regions[activeRegion]?.download_urls[2]
        }
      ];
    }
    if (activeView === "country") {
      return [
        {
          label: "DOWNLOAD PNG",
          value: countries[activeCountry]?.download_urls[0]
        },
        {
          label: "DOWNLOAD PDF",
          value: countries[activeCountry]?.download_urls[1]
        },
        {
          label: "DOWNLOAD JPEG",
          value: countries[activeCountry]?.download_urls[2]
        }
      ];
    }
    if (activeView === "worldwide") {
      return [
        {
          label: "DOWNLOAD PNG",
          value: globals.download_urls[0]
        },
        {
          label: "DOWNLOAD PDF",
          value: globals.download_urls[1]
        },
        {
          label: "DOWNLOAD JPEG",
          value: globals.download_urls[2]
        }
      ];
    }
  };

  const getPlaceholder = () => {
    try {
      if (activeView === "worldwide") {
        return "DOWNLOAD";
      }
      if (activeView === "region") {
        return "DOWNLOAD";
      }
      if (activeView === "country") {
        return "DOWNLOAD";
      }
    } catch (error) {
      return "DOWNLOAD";
    }
  };

  // lg:top-[80px] md:top-[175px] sm:top-[160px] top-[160px] md:right-[20px] right-[15px]
  const { downloads } = useSnapshot(apiData);
  return (
    <a
      href={downloads[0].map}
      target="_blank"
      rel="noopener noreferrer"
      className="px-3 py-1 flex flex-row items-center justify-start space-x-2 space-y-1 border-yellow-400 border-2 bg-white k-[1000] shadow-md"
    >
      <div>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 9L2.25 5.25L3.3 4.1625L5.25 6.1125V0H6.75V6.1125L8.7 4.1625L9.75 5.25L6 9ZM0 12V8.25H1.5V10.5H10.5V8.25H12V12H0Z"
            fill="#808094"
          />
        </svg>
      </div>
      <span className="text-center text-xs font-bold pb-[5px]">DOWNLOAD</span>
    </a>
  );
};

export default DownloadButton;
